import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { AnchorLink } from "./AnchorLink";
export const CustomLink = ({
  children,
  href,
  ...rest
}) => {
  const router = useRouter();
  if (router.pathname === "/puja/[id]") {
    return <AnchorLink href={href}>{children}</AnchorLink>;
  }
  return <Link href={href} {...rest} rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-component="CustomLink" data-sentry-source-file="CustomLink.jsx">
      {children}
    </Link>;
};